// removed by extract-text-webpack-plugin
module.exports = {"input":"FieldCheckbox__input___3mezx","mini-label":"FieldCheckbox__mini-label___YF0cj","input-error":"FieldCheckbox__input-error___1y1jC FieldCheckbox__input___3mezx","checkbox":"FieldCheckbox__checkbox___2KoyB"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/packages/components/Form/FieldCheckbox.scss
// module id = 528
// module chunks = 0